import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Card, Menu, Avatar } from 'antd'
import { app, use, config } from 'xadmin'
import { Icon } from 'xadmin-ui';
import {onAuthorization} from '../../components/util'
const { SubMenu } = Menu;

const defaultMenu = [
  {
    title: '资产管理',
    key: '2',
    url: '/app/nodes',
    icon: <Icon className="nav-icon" svg={require('./../../icon/Node.svg')} />,
    children: []
  },
  {
    title: '报表管理',
    key: '6',
    url: '/app/model/Report/list',
    icon: <Icon className="nav-icon" svg={require('./../../icon/Report.svg')} />,
    children: []
  },
  {

    title: '报警处理',
    key: '23',
    url: '/app/model/Warning/list',
    icon: <Icon className="nav-icon" svg={require('./../../icon/homeIcon/报警处理.svg')} />,
    children: []
  },
  {
    title: '数据分析',
    key: '7',
    url: '/app/chart',
    icon: <Icon className="nav-icon" svg={require('./../../icon/homeIcon/数据分析.svg')} />,
    children: []
  },
  {
    title: '在线状态',
    key: '21',
    url: '/app/network/status',
    icon: <Icon className="nav-icon" svg={require('./../../icon/OnlineEdit.svg')} />,
    children: []
  },
  {
    title: '操作日志',
    key: '22',
    url: '/app/model/Log/list',
    icon: <Icon className="nav-icon" svg={require('./../../icon/Log.svg')} style={{ color: 'red' }} />,
    children: []
  }
]

const MainMenu = (props) => {
  const { name, canClick = true } = props
  const { user, user: { rolesObjList: roles }, settings } = use('redux', state =>
    ({ user: state.user, settings: state.settings }))
  const [selectedKeys, setSelectedKeys] = useState([])
  const [openKeys, setOpenKeys] = useState([])
  const [curWidth, setCurWidth] = useState(300)

  const pathname = location.hash?.substring(1)


  let value = null
  if (user[name] && user[name].length > 0) {
    value = user[name]
  } else if (roles) {
    for (let i = 0; i < roles.length; i++) {
      const role = roles[i]
      if (role[name] && role[name].length > 0) {
        value = role[name]
        break
      }
    }
  }
  if (!value) {
    if (settings[name] && settings[name].length > 0) {
      value = settings[name]
    } else {
      value = name == 'mainmenu' ? defaultMenu : []
    }
  }

  const MenuClick = url => {
    if (url && canClick) {
      if (url.indexOf('http') >= 0) {
        window.open(url)
      } else {
        app.go(url)
      }
    }
  }

  const GetMenu = (menuTreeData) => {
    if (!menuTreeData || _.isEmpty(menuTreeData)) return
    return menuTreeData.map(item => {
      let titileIcon = <Avatar className="nav-icon" shape="square" />
      const src = item.icon
      if (src) {
        if (_.isString(src) && src.indexOf('/') > -1) {
          titileIcon = <Avatar className="nav-icon" shape="square" src={config('mediaUrl') + src} />
        } else {
          const icons = app.get('icons')
          const icon = _.find(icons, item => item.name == src)
          if (icon) {
            titileIcon = <Icon className="nav-icon" svg={icon.url} />
          } else {
            titileIcon = <span className="nav-icon nav-icon-text" >{item.icon}</span>
          }
        }
      }
      if(!onAuthorization(item.permission)){
        return null
      }
      if (item.children && item.children.length > 0) {
        return (
          <SubMenu
            className={props.mode == 'horizontal' ? 'submenu-reset' : ''}
            title={
              <a className="submenu-title-wrapper" onClick={() => item.url && MenuClick(item.url)}>
                {titileIcon}
                <span className="nav-text" >{item.title}</span>
              </a>
            }
            key={item.key}
          >
            {GetMenu(item.children)}
          </SubMenu>
        )
      }
      return (
        <Menu.Item key={item?.url || item.key}>
          <a onClick={() => item.url && MenuClick(item.url)}>
            {titileIcon}
            <span className="nav-text" >{item.title}</span>
          </a>
        </Menu.Item>
      )
    })
  }
  const style = props.mode == 'horizontal' ? {
    width: `calc( 100% - ${curWidth}px )`,
    flex: 1
  } : { width: '100%' }


  React.useEffect(() => {
    const logoDom = document.querySelector('#front-logo')
    const logoDomWidth = logoDom?.getBoundingClientRect()?.width || 350
    setCurWidth(logoDomWidth + 350)
  }, [])

  const onClick = v => {
    props.setIsHome(false)
    setSelectedKeys(v.keyPath)
  }
  // console.log(value)
  return (
    <Menu
      mode={props.mode}
      onClick={onClick}
      openKeys={openKeys}
      style={{ ...style, borderRight: 0 }}
      onOpenChange={setOpenKeys}
      selectedKeys={[pathname]}
      className={props.className ? 'main-menu inline-menu-custom' : 'main-menu block-menu-custom'}
    >
      {GetMenu(value)}
    </Menu>
  )
}

export default MainMenu
